import API from '../utils/api';
import { TRANSLATIONS_RETAIL_API_ENDPOINT } from '../constants/defaultValues';

const getTranslations = async () => {
    const params = { app: 'ssbt' };

    const result = await API.get(`${TRANSLATIONS_RETAIL_API_ENDPOINT}/translation/formatted-list`, {
        params,
    });

    return result.data;
};

const TranslationService = {
    getTranslations,
};

export default TranslationService;
